import script from "./UserImagePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./UserImagePreview.vue?vue&type=script&setup=true&lang=js"

import "./UserImagePreview.vue?vue&type=style&index=0&id=5afbbc71&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afbbc71"]])

export default __exports__